__turbopack_context__.v({
  "card": "gct-wG_card",
  "container": "gct-wG_container",
  "raised": "gct-wG_raised",
});
